import { createContext } from 'react';
export var RcMenuListContext = createContext({
    menuListId: '',
    autoClose: false,
    focusedMenuItemId: null,
    setFocusedMenuItemId: function () { return null; },
    onClose: undefined,
});
